import { createRoutine } from 'redux-saga-routines';

export const fetchInventoryItemTagsOptions = createRoutine(
  'FETCH_INVENTORY_ITEM_TAGS_OPTIONS'
);

export const fetchInventoryPackageTagsOptions = createRoutine(
  'FETCH_INVENTORY_PACKAGE_TAGS_OPTIONS'
);

export const fetchInventoryItemAvailabilityLocationZoneOptions = createRoutine(
  'FETCH_INVENTORY_ITEM_AVAILABILITY_LOCATION_ZONE_OPTIONS'
);

export const fetchInventoryPackageAvailabilityLocationOptions = createRoutine(
  'FETCH_INVENTORY_PACKAGE_AVAILABILITY_LOCATION_OPTIONS'
);

export const fetchTrackingMethodOptions = createRoutine(
  'FETCH_INVENTORY_TRACKING_METHOD_OPTIONS'
);
